export default {
  banner: {
    title: "连接全球人与应用",
    subtitle:
      "Authing 快速实现任何 Web、App 和企业软件的身份认证和用户管理，为你的客户和员工提供完善的登录解决方案。",
    "try-time-tip": "多达 8,000 月活跃用户",
    "try-function-tip": "体验三大业务场景",
  },
  customer: "Authing 已帮助 20000+ 家企业和开发者构建标准化的用户身份体系",
  management: {
    title: "身份管理，就该如此便捷",
    "item-one": {
      title: "用户身份解决方案",
      subtitle: "五行代码为你的客户打造安全无缝的认证体验",
      "list-one": "集成第三方登录",
      "list-two": "手机号码闪验",
      "list-three": "多因素认证 MFA",
      "list-four": "单点登录 SSO",
      "list-five": "通用登录组件",
      "list-six": "自定义认证流程",
    },
    "item-two": {
      title: "员工身份解决方案",
      subtitle: "无需开发，集成企业内部系统，统一管控员工的身份权限",
      "list-one": "单点登录 SSO",
      "list-two": "多因素认证 MFA",
      "list-three": "支持私有化部署",
      "list-four": "权限管理",
      "list-five": "成员号码闪验",
    },
  },
  api: {
    "title-dot-one": "用",
    "title-dot-two": "，帮",
    "title-dot-three": "省",
    "title-dot-one-first": "完善的 API",
    "title-dot-one-second": "统一的管理",
    "title-dot-one-third": "灵活的登录",
    "title-dot-two-first": "开发者",
    "title-dot-two-second": "企业",
    "title-dot-two-third": "用户",
    "title-dot-three-first": "时",
    "title-dot-three-second": "钱",
    "title-dot-three-third": "事",
    roi: {
      userRate: "终端用户转化率",
      maintenanceCost: "运维成本",
      developmentTime: "开发工时",
      dataFrom: "数据来源于 GARTNER",
    },
    doc: {
      type: "文档",
      title: "快速开始",
      descript: "学习使用 Authing 及我们提供的 API",
    },
    community: {
      type: "社区",
      title: "开发者论坛",
      descript: "与 Authing 的工程师和用户在线交流",
    },
  },
  infrastructure: {
    title: "云计算的身份基础设施",
    subtitle:
      "以身份为中心，在所有 SaaS 软件和用户中建立身份共享的社会性基础设施，帮助企业构建安全的现代 IT 基础设施，不仅保护公司业务，更重新定义用户体验。",
    img:
      "//files.authing.co/authing-website/home-identity-infrastructure-v2.png",
  },
  application: {
    title: "快速接入数千应用，尽在 Authing 合作网络",
    subtitle:
      "Authing 已经构建一个应用生态，任何用户想要的应用，都会直接出现在 Authing 的集成网络中，便捷快速的接入",
    toApn: "进入合作网络",
  },
  connection: {
    title: "安全的未来，现在连接",
    subtitle:
      "在复杂的身份生态和应用生态中，无数身份通过无边界的方式访问应用和资源，而 Authing 就是这些身份安全连接的基础。",
  },
  certification: {
    title: "获得众多合规认证",
  },
  tryOn: {
    title: "快速集成 五分钟实现",
    subtitle: "单点登录、认证授权、权限管理等功能",
  },
};
